import { memo } from "react";
import { GRID_ACTIONS_COLUMN_TYPE, GridRowParams } from "@mui/x-data-grid";
import { useTypedSelector } from "hooks";
import { TableGridMode } from "consts/table";
import { selectSetupActiveCompanyOptions } from "features/general/selectors";
import {
    selectSetupsSlice,
    selectIsSetupsLoading,
    selectIsSetupsUninitialized
} from "features/setups/selectors";
import ResourceLayout from "ui/layouts/Resource";
import { ResourceProvider, Resource } from "ui/widgets/Resource";
import useGeneralSetups from "./useGeneralSetups";
import GeneralSetupsToolBar from "./GeneralSetupsToolbar";
import GeneralSetupsDetails from "./GeneralSetupsDetails";
import Actions from "./Actions";

const GeneralSetups = () => {
    const { filterTypes } = useGeneralSetups();

    return (
        <ResourceLayout
            breadcrumbsProps={{
                heading: 'General Setups',
                links: [{ name: '' }],
                sx: {
                    mb: 0
                }
            }}
        >
            <Resource
                name='General Setups'
                useResource={useGeneralSetups}
                mode={TableGridMode.GeneralSetup}
                selectIsTableUninitialized={selectIsSetupsUninitialized()}
                selectIsTableLoading={selectIsSetupsLoading()}
                selectTableDataSlice={selectSetupsSlice()}
                Toolbar={GeneralSetupsToolBar}
                Detail={GeneralSetupsDetails}
                FiltersProps={{
                    sx: {
                        m: 0
                    },
                    filtersModelOverrides: {
                        Domains: useTypedSelector(selectSetupActiveCompanyOptions)
                    }
                }}
                LayoutProps={{
                    sx: {
                        m: '24px 0px'
                    }
                }}
                filterTypes={filterTypes}
                initialState={{
                    pinnedColumns: {
                        right: [GRID_ACTIONS_COLUMN_TYPE]
                    }
                }}
                columns={[
                    {
                        field: GRID_ACTIONS_COLUMN_TYPE,
                        type: GRID_ACTIONS_COLUMN_TYPE,
                        getActions: ({ row }: GridRowParams) => [
                            <Actions
                                {...row}
                            />
                        ]
                    }
                ]}
            />
        </ResourceLayout>
    );
};

export default memo(() => (
    <ResourceProvider>
        <GeneralSetups />
    </ResourceProvider>
));